export default "__VITE_PUBLIC_ASSET__480412a7__"